// extracted by mini-css-extract-plugin
export default {"breadcrumbs":"Breadcrumbs__breadcrumbs___eX5Il","disabled":"Breadcrumbs__disabled___spCWR"};